import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Navbar from './Component/Navbar';
import Hero from './Component/Hero';
import About from './Component/About';
import Stats from './Component/Stats';
import Journey from './Component/Journey';
import Gallery from './Component/Gallery';
import Contact from './Component/Contact';
import Footer from './Component/Footer';


export default function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Stats />
      <Journey />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}